import { render, staticRenderFns } from "./BankDocumentPayment.vue?vue&type=template&id=8db58660&lang=pug&"
import script from "./BankDocumentPayment.vue?vue&type=script&lang=js&"
export * from "./BankDocumentPayment.vue?vue&type=script&lang=js&"
import style0 from "./BankDocumentPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BankDocumentPayment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VTextField,
})
